import scheme from './scheme'
import methods from './methods'
import components from './components'

export default {
  scheme,
  methods,
  components
}
